.layout {
  min-height: 100vh;
  background-color: var(--bg-primary);
  position: relative;
}

.main {
  padding-top: var(--navbar-height);
  min-height: 100vh;
}
